import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import "./PremiumDashboard.css";
import { Auth } from "aws-amplify";

export default function PremiumDashboard() {
    const [subscription, setSubscription] = useState(null);
    const [loading, setLoading] = useState(true);
    const [canceling, setCanceling] = useState(false);
    const [error, setError] = useState("");
    const [purchasedPlan, setPurchasedPlan] = useState(null);
    const [planStatus, setPlanStatus] = useState(null);
    const [subscriptionStatus, setSubscriptionStatus] = useState("inactive");
    const [renewalDate, setRenewalDate] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const getToken = async () => {
        try {
            const user = await Auth.currentAuthenticatedUser();
            const session = await Auth.currentSession();
            const jwt = session.getIdToken().getJwtToken();
            const usernameOrEmail = user.username.includes("Google_")
                ? user.attributes.email
                : user.username;

            return [usernameOrEmail, jwt];
        } catch (error) {
            await Auth.signOut();
            return [null, null];
        }
    };

    const fetchSubscriptionDetails = async () => {
        const [username, jwt] = await getToken();
        try {
            setLoading(true);

            const response = await fetch("https://api.quizwizard.net/quiz/getStripeSubscriptionDetails", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ username }),
            });

            const data = await response.json();
            if (response.ok) {
                let body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

                setPurchasedPlan(body.purchased_plan);
                setPlanStatus(body.planStatus === "active" ? "Active" : "Not Active");
                setRenewalDate(body.renewal_date);
                setSubscriptionStatus(body.subscriptionStatus ? "Cancelled" : "Active");
                setSubscription(body);
            } else {
                setError(data.error || "Failed to fetch subscription.");
            }
        } catch (err) {
            setError("An error occurred while fetching subscription.");
        } finally {
            setLoading(false);
        }
    };

    const handleCancelConfirmed = async () => {
        try {
            setCanceling(true);
            setShowModal(false);
            const [username, jwt] = await getToken();

            const response = await fetch("https://api.quizwizard.net/quiz/cancel-subscription", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username }),
            });

            const data = await response.json();
            if (response.ok) {
                alert("Subscription cancelled successfully.");
                setTimeout(() => {
                    fetchSubscriptionDetails();
                }, 1000);
            } else {
                setError(data.error || "Failed to cancel subscription.");
            }
        } catch (err) {
            setError("An error occurred while canceling.");
        } finally {
            setCanceling(false);
        }
    };

    useEffect(() => {
        fetchSubscriptionDetails();
    }, []);

    return (
        <div className="premium-dashboard-container">
            <div className="subscription-card">
                <h2 className="subscription-title">Your Subscription</h2>
                {loading ? (
                    <p className="subscription-info">Loading...</p>
                ) : error ? (
                    <p className="subscription-error">{error}</p>
                ) : subscription ? (
                    <>
                        <div className="subscription-details">
                            <div className="detail-item"><strong>Plan:</strong> {purchasedPlan}</div>
                            <div className="detail-item"><strong>Status:</strong> {planStatus}</div>
                            <div className="detail-item"><strong>Auto Renewal:</strong> {subscriptionStatus}</div>
                            <div className="detail-item"><strong>Expiry Date:</strong> {renewalDate}</div>
                        </div>
                        {subscriptionStatus === "Active" && (
                            <button
                                className="cancel-button"
                                onClick={() => setShowModal(true)}
                                disabled={canceling}
                            >
                                {canceling ? "Cancelling..." : "Cancel Subscription"}
                            </button>
                        )}
                    </>
                ) : (
                    <p className="subscription-info">No active subscription found.</p>
                )}
            </div>

            {showModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <p className="modal-text">Are you sure you want to cancel your subscription?</p>
                        <div className="modal-actions">
                            <button onClick={handleCancelConfirmed} className="confirm-btn">Yes</button>
                            <button onClick={() => setShowModal(false)} className="cancel-btn">No</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );

}
